import { Injectable } from "@angular/core";
import { DataService } from "../../DataService/data.service";
import { Observable } from "rxjs";
import { IContractedCategory } from "src/app/Models/Interface/Client/Contract/ContractedItems/contracted-category";
import { HttpParams } from "@angular/common/http";
import { APIName } from "../../../Models/APIEndPoints/APIName";
import { IPagination } from "src/app/Models/Interface/Pagination/pagination";
import { ESortDirection } from "src/app/Models/Enum/sort-direction";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { IContractedItem } from "src/app/Models/Interface/Client/Contract/ContractedItems/contracted-item";
import { IEditContractedItem } from "src/app/Models/Interface/Client/Contract/ContractedItems/edit-contracted-item";
import { IProduct } from "src/app/Models/Interface/Products/product";

@Injectable({
  providedIn: "root",
})
export class ContractedItemsService {
  keyword: string = "";
  sort: string = ESortDirection.ASCENDING;
  pagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
    leftItems: 0,
  } as IPagination;
  categoryId: number = 0;
  editContractedItemOBJ = {} as IEditContractedItem;

  constructor(private dataService: DataService) {}

  getCategories(clientId: number): Observable<IContractedCategory[]> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("clientId", clientId);
    return this.dataService.getWithParams(
      APIName.clientContract.contractedItems.contractedItemsCategory,
      params
    );
  }

  getContractedItems(
    clientId: number
  ): Observable<IBaseDataList<IContractedItem[]>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("ClientId", clientId);
    params = params.append("Keyword", this.keyword);
    params = params.append("Sort", this.sort);
    params = params.append("Skip", this.pagination.skip);
    params = params.append("Take", this.pagination.take);
    params = params.append("CategoryId", this.categoryId);
    return this.dataService.getWithParams(
      APIName.clientContract.contractedItems.contractedItems,
      params
    );
  }

  editContractedItem(): Observable<any> {
    return this.dataService.post(
      APIName.clientContract.contractedItems.editItemPrice,
      this.editContractedItemOBJ
    );
  }

  onRemoveContractedItem(contractedProductId: number): Observable<any> {
    return this.dataService.post(
      APIName.clientContract.contractedItems.removeContractedItem,
      { contractedProductId }
    );
  }

  getAllProducts(contractId: any): Observable<IBaseDataList<IProduct[]>> {
    let params = new HttpParams();
    params = params.append("Skip", this.pagination.skip);
    params = params.append("Take", this.pagination.take);
    params = params.append("Keyword", this.keyword);
      params = params.append("InContract", true);

      params = params.append("StatusCode", "active");

    params = params.append("CategoryId", this.categoryId);
    if (contractId) params = params.append("ContractId", contractId);
    
    return this.dataService.getWithParams(APIName.products.getAll, params);
  }
}
